import { Injectable } from '@angular/core';
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

import {environment} from '@app/environment';

@Injectable({
    providedIn: 'root'
})
export class DemoozGoogleMapsService {

    constructor() { }
    
    init() {
        setOptions({ key: environment.GOOGLE_MAPS_API_KEY });
    }
    
    async Geocoding(){
        const { Geocoder } = await importLibrary("geocoding");
        return Geocoder;
    }
    
    async AutocompleteSessionToken(){
        const { AutocompleteSessionToken } = await importLibrary("places");
        return AutocompleteSessionToken;
    }
    
    async AutocompleteSuggestion(){
        const { AutocompleteSuggestion } = await importLibrary("places");
        return AutocompleteSuggestion;
    }
        
    async Place(){
        const { Place } = await importLibrary("places");      
        return Place;
    }
    
}

